module.exports = __webpack_public_path__ + "img/frame.cf57fd1b.png";